export const ASSISTANT_PANEL_WIDTH = 420;
export const ASSISTANT_PANEL_WIDTH_EXPANDED = 720;
export const ASSISTANT_DOCK_MIN_WIDTH_PX = 1400;
export const ASSISTANT_FAB_SIZE = 56;
export const ASSISTANT_FAB_MARGIN = 24;
export const ASSISTANT_FAB_MOBILE_SIZE = 44;
export const ASSISTANT_FAB_MOBILE_MARGIN = 12;
export const ASSISTANT_PANEL_GAP = 12;
